import { useContext, useState } from "react";
import WithBackground from "../../../core/boilerplate/WithBackground";
import CustomToggle from "../../../helperComponents/CustomToggle";
import LoggedOutHeader from "../landingPage/LoggedOutHeader";
import styled from "styled-components";
import MaterialInput from "../../../helperComponents/MaterialInput";
import extractEventValue from "../../../../controllers/utils/extractEventValue";
import InputCard from "../../../helperComponents/InputCard";
import CustomButton from "../../../helperComponents/CustomButton";
import LoadingSection from "../../../helperComponents/LoadingSection";
import { serverLine } from "../../../../controllers/network/serverLine";
import saveUserAuth from "../../../../controllers/auth/saveUserAuth";
import { useTranslation } from "react-i18next";
import BrandContainer from "../../../brand/BrandContainer";
import Context from "../../../../Context";
import SwipeBack from "../../loggedIn/SwipeBackGesture";
import AnimatedPage from "../../loggedIn/AnimatedPage";
import AnimatedPillTabs from "../landingPage/loggedOutHomeForApp/AnimatedPillTabs";
import BadgeLogo from "../../../customUiForCs/logo/BadgeLogo";
import ColorThemeSelector from "../../loggedIn/ColorThemeSelector";

const HorizontalContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100vw;
  gap: 0;
  justify-content: space-between;
`;

const LeftSide = styled.div`
  display: flex;
  flex-direction: column;
  width: 50vw;
  height: 100vh;
  position: relative;
  justify-content: center;
  align-items: center;
`;

const RightSide = styled.div`
  display: flex;
  flex-direction: column;
  width: 50vw;
  height: 100vh;
  justify-content: center;
  align-items: center;
  background: var(--loginBackground);
  border-left: 2px solid var(--borderDim);
`;
const Form = styled.div`
  display: flex;
  flex-direction: column;
  gap: 30px;
  width: 100%;
  align-items: center;
  /* padding-bottom: 30px; */
`;

const Inputs = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
  width: 100%;
  /* height: 220px; */
  /* background-color: red; */
  align-items: center;
`;

const AppUIContainer = styled.div`
  display: flex;
  height: 100%;
  flex-direction: column;
  gap: 0;
  justify-content: center;
  align-items: center;
  padding-bottom: 40px;
`;
const ImageSectionApp = styled.div`
  border-radius: 15px;
  height: calc(100dvh - (var(--safe-area-inset-top) + 450px));
  /* height: auto; */
  /* flex: 1; */
  width: 100vw;
  object-fit: cover;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const MobileAuthSection = styled.div`
  /* position: absolute; */
  /* bottom: 0; */
  /* box-shadow: 0 -10px 50px 50px #000; */
  padding: 0 30px;
  width: 100vw;
  background: var(--loginBackground);
  height: auto;
  display: flex;
  flex: 1;
  /* flex: 1; */
  max-height: 450px;
  padding-top: 15px;
  border-top: 1px solid var(--loginBorder);

  justify-content: center;
  align-items: center;
  /* border-radius: 10px 10px 0 0; */
  overflow: hidden;
`;

const Top = styled.div`
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 0;
  left: 0;

  width: 100%;
  padding-top: 10px;
  background: linear-gradient(0deg, transparent, 20%, #000, #000);
  height: 80px;
`;

const ThemeSection = styled.div`
  position: absolute;
  bottom: 20px;
  left: 35%;
  width: 30%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 20px;
`;

const options = [
  { value: "LOGIN", label: "Connexion" },
  { value: "SIGNUP", label: "S'inscrire" },
];

export default function LoginPage({ initialType }) {
  const { isMobile } = useContext(Context);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  let core = (
    <InputCard
      // title="Bienvenue"
      submitButtonText={"Connexion"}
      onSubmit={submit}
      submitButtonProps={{
        elementColor: "var(--loginElementPrimary) !important", //to replace mui styling
        surfaceColor: "var(--loginSurfacePrimary)",
      }}
    >
      <Form>{getInputs()}</Form>
    </InputCard>
  );

  if (loading)
    core = (
      <InputCard>
        <LoadingSection />
      </InputCard>
    );

  if (isMobile) return getAppUI();

  return (
    <AnimatedPage>
      <WithBackground>
        <HorizontalContainer>
          <LeftSide>
            <BadgeLogo />

            <ThemeSection>
              <ColorThemeSelector />
            </ThemeSection>
          </LeftSide>

          <RightSide>{core}</RightSide>
        </HorizontalContainer>
      </WithBackground>
    </AnimatedPage>
  );

  function getAppUI() {
    return (
      <SwipeBack>
        <AnimatedPage>
          <AppUIContainer>
            <WithBackground>
              <ImageSectionApp>
                <BadgeLogo />
              </ImageSectionApp>

              <MobileAuthSection>{core}</MobileAuthSection>
            </WithBackground>
          </AppUIContainer>
        </AnimatedPage>
      </SwipeBack>
    );
  }

  function submit() {
    login();
  }

  async function login() {
    if (!email) return window.popupAlert("Please input the email");
    if (!password) return window.popupAlert("Please input the password");

    try {
      setLoading(true);
      let authData = await serverLine.post("/email-login", { email, password });

      setLoading(false);
      saveUserAuth(authData);
    } catch (e) {
      setLoading(false);
      window.popupAlert(e.message);
    }
  }

  function getInputs() {
    return (
      <Inputs>
        <MaterialInput
          label={"Email"}
          value={email}
          onChange={extractEventValue(setEmail)}
          surfaceColor="var(--loginSurface)"
          elementColor="var(--loginElement)"
          borderColor="var(--loginBorder)"
        />
        <MaterialInput
          type="password"
          label={"Mot de passe"}
          value={password}
          onChange={extractEventValue(setPassword)}
          surfaceColor="var(--loginSurface)"
          elementColor="var(--loginElement)"
          borderColor="var(--loginBorder)"
        />
        <CustomButton
          variant="minimal-underlined"
          customVariant="slightlyContained"
          href="/generate-otp"
          surfaceColor="var(--loginSurfaceDim)"
          elementColor="var(--loginElementDim)"
        >
          Se connecter avec otp
        </CustomButton>
      </Inputs>
    );
  }
}
